import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function successHandler(message: string, autoClose = 2000) {
  toast.success(message, {
    position: "top-center",
    autoClose: autoClose,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
}